import React from 'react';
import Logo from '~/components/Logo';
import Container from '~/components/ui/Container';
import { cn } from '~/helpers/utils';
import { useHeadroom } from '~/hooks/useHeadroom';

interface HeaderProps extends React.HTMLAttributes<HTMLElement> {
  imageUrl?: string;
}

const CustomizableHeader = ({ imageUrl, className, ...props }: HeaderProps) => {
  const headroom = useHeadroom();

  return (
    <header
      role="banner"
      className={cn(
        'campaign-header sticky top-0 z-[999999] transition-transform duration-300',
        headroom === 'unpinned' ? '-translate-y-full' : 'translate-y-0',
        className
      )}
      {...props}
    >
      <Container>
        {imageUrl && (
          <a className="inline-block">
            <img
              loading="lazy"
              src={imageUrl as string}
              alt="Via Advieskeuze"
            />
          </a>
        )}

        {!imageUrl && <Logo link="/" />}
      </Container>
    </header>
  );
};

CustomizableHeader.displayName = 'Header';

export default CustomizableHeader;
